import { createRouter, createWebHashHistory ,createWebHistory} from 'vue-router'
import Index from '@/views/index.vue'

const routes = [
  {
    path: '/',
    name: 'index',
    component: Index
  },
  {
    path: '/privacy',
    name: 'privacy',
    component:()=>import('@/views/privacy.vue')
  },
  {
    path: '/privacy_copy',
    name: 'privacy_copy',
    component:()=>import('@/views/privacy_copy.vue')
  },
  {
    path: '/agreement',
    name: 'agreement',
    component:()=>import('@/views/agreement.vue')
  },
  {
    path: '/agreement_copy',
    name: 'agreement_copy',
    component:()=>import('@/views/agreement_copy.vue')
  }
]

const router = createRouter({
  history: createWebHashHistory(),
  routes
})

export default router
